import React from "react";
import PageWrapper from "./PageWrapper";
import * as Const from "./../_Const";
import useScreenType from "./../hooks/useScreenType";

const WarningPage = ({ title, warning, message, index }) => {
  const screenType = useScreenType();
  const isTerminal = Const.isTerminal();

  function replaceWithBr(text) {
    return text?.replace(/\n/g, "<br />") ?? text;
  }

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "parent":
          css = "mt-8";
          break;
        case "rect":
          css = "mx-2 h-28";
          break;
        case "warning":
          css = "text-6xl";
          break;
        case "text":
          css = "text-3xl mt-8 mx-0";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "parent":
          css = "mt-8";
          break;
        case "rect":
          css = "mx-6 h-36";
          break;
        case "warning":
          css = "text-6xl";
          break;
        case "text":
          css = "text-5xl mt-28";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "parent":
          css = "mt-8";
          break;
        case "rect":
          css = "mx-6 h-36";
          break;
        case "warning":
          css = "text-6xl";
          break;
        case "text":
          css = "text-5xl mt-28";
          break;
      }
    } else if (screenType === Const.SCREEN_PHONE) {
      switch (what) {
        case "parent":
          css = "mt-8";
          break;
        case "rect":
          css = "mx-6 h-36";
          break;
        case "warning":
          css = "text-[1.92rem]";
          break;
        case "text":
          css = "text-xl mt-8";
          break;
      }
    }
    //console.log(what, screenType, css);

    return css;
  }

  if (screenType === Const.SCREEN_UNKNOWN) {
    return;
  }

  return (
    <PageWrapper title={title} index={index} showTitleOnNavbar={isTerminal ? true : false}>
      <div className={`${getCssFor("parent")} flex flex-col`}>
        <div className={`${getCssFor("rect")} bg-error flex justify-center items-center`}>
          <p className={`${getCssFor("warning")} text-white uppercase`}>{warning}</p>
        </div>
        <p className={`${getCssFor("text")} text-center text-accent-dark dark:text-accent`}>
          <span dangerouslySetInnerHTML={{ __html: replaceWithBr(message) }} />
        </p>
      </div>
    </PageWrapper>
  );
};

export default WarningPage;
